/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UserLite } from './userLite';

export interface SourceOut {
  id: string;
  kind: string;
  channel: string | null;
  role: string;
  diarization_quality: string;
  duration_s: number | null;
  has_media: boolean;
  has_transcript: boolean;
  created_from: string;
  transcript_attempts: number;
  asr_provider: string | null;
  attested_at: string | null;
  uploaded_by: UserLite | null;
  display_name: string | null;
}
